<div [ngClass]="{'library-button': true, 'white-background': additionalCssClass == 'white-background'}" (click)="controller.goToLibrary()">
  <!-- <i class="fa fa-chevron-left"></i> -->

  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8L18 6L9 15L18 24L20 22L13 15L20 8Z"/>
  </svg>

  <div style="line-height:34px;margin-left:8px"><span>content library</span></div>
</div>

<div [ngClass]="{'copy-link': true, 'white-background': additionalCssClass == 'white-background'}" (click)="controller.copyLink()">
  @if (controller.linkCopied()) {
    <div>✓ Link copied!</div>
  }
  @if (!controller.linkCopied()) {
    <div> Copy link </div>
  }
</div>
